export default "__VITE_ASSET__q6dZ6rxe__"